module.exports = __webpack_public_path__ + "img/import.67a3230d.png";